import { render } from "./ServiceHeaderNavigation.vue?vue&type=template&id=304d3c4c"
import script from "./ServiceHeaderNavigation.vue?vue&type=script&lang=js"
export * from "./ServiceHeaderNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__